(function () {
  "use strict";

  const config = {
    alertCount: 0,
    maxTime: 0,
    lastTime: 0,
    video: null,
    outputDiv: null,
    staticDiv: null,
    isListening: false,
  };

  const initializeUI = () => {
    if (config.outputDiv) {
      config.outputDiv.remove(); // Eski UI öğelerini kaldır
    }

    config.outputDiv = document.createElement("div");
    Object.assign(config.outputDiv.style, {
      position: "fixed",
      top: "0",
      // right: "0",
      width: "300px",
      height: "100%",
      padding: "20px",
      fontSize: "11px",
      pointerEvents: "none",
      background: "rgba(0,0,0,0.1)",
      color: "#FFF",
      visibility: "hidden",
    });
    config.outputDiv.className = "edulock";
    config.outputDiv.innerHTML = `<h4>EduLock <small>1.1</small></h4>`;
    document.body.appendChild(config.outputDiv);

    config.staticDiv = document.createElement("div");
    Object.assign(config.staticDiv.style, {
      color: "#800000",
      fontSize: "11px",
    });
    config.staticDiv.className = "edulock_statics";
    config.outputDiv.appendChild(config.staticDiv);

    document.addEventListener("keydown", (event) => {
      if (event.shiftKey && event.code === "Space") {
        const isVisible = config.outputDiv.style.visibility === "visible";
        config.outputDiv.style.visibility = isVisible ? "hidden" : "visible";
      }
    });
  };

  const setError = (message) => {
    config.alertCount++;
    const alertId = `alert-pop-${config.alertCount}`;
    const alertDiv = document.createElement("div");
    alertDiv.className = `alert alert-dismissible alert-danger animated ${alertId}`;
    alertDiv.innerHTML = `#${config.alertCount}: ${message}`;
    config.outputDiv.appendChild(alertDiv);

    setTimeout(() => {
      const alertElement = document.querySelector(`.${alertId}`);
      if (alertElement) alertElement.remove();
    }, 2000);
  };

  const handleTimeUpdate = () => {
    if (!config.video) return;
    if (config.video.currentTime > config.maxTime + 2) {
      setError("Bu alan izlenmemiş. İlerleme engellendi.");
      config.video.currentTime = config.maxTime;
    } else {
      config.lastTime = config.video.currentTime;
      config.maxTime = Math.max(config.maxTime, config.lastTime);
    }
  };

  const handleSeeking = () => {
    if (!config.video) return;
    if (config.video.currentTime > config.maxTime) {
      setError("Bu alan izlenmemiş. İlerleme engellendi.");
      config.video.currentTime = config.maxTime;
    }
  };

  const handleEnterPictureInPicture = (event) => {
    if (!config.video) return;
    config.video.disablePictureInPicture = true;
    setError("Picture-in-Picture Algılandı.");
    event.preventDefault();
  };

  const attachVideoListeners = (video) => {
    if (!video || config.isListening) return;

    video.playbackRate = 1;
    video.disablePictureInPicture = true;

    video.addEventListener("timeupdate", handleTimeUpdate);
    video.addEventListener("seeking", handleSeeking);
    video.addEventListener(
      "enterpictureinpicture",
      handleEnterPictureInPicture
    );

    config.isListening = true;
    setError("Video olayları başarıyla bağlandı.");
  };

  const removeVideoListeners = (video) => {
    if (!video || !config.isListening) return;

    video.removeEventListener("timeupdate", handleTimeUpdate);
    video.removeEventListener("seeking", handleSeeking);
    video.removeEventListener(
      "enterpictureinpicture",
      handleEnterPictureInPicture
    );

    config.isListening = false;
  };

  const initialize = () => {
    const videos = document.querySelectorAll("video");
    if (videos.length > 0) {
      config.video = videos[0];
      attachVideoListeners(config.video);
    } else {
      setError("Video öğesi bulunamadı.");
    }

    setInterval(() => {
      if (config.video && config.video.playbackRate > 1) {
        setError(`Hız değişti: ${config.video.playbackRate}`);
        config.video.playbackRate = 1;
      }
    }, 1000);
  };

  window.edulock = () => {
    if (config.video) {
      removeVideoListeners(config.video);
    }

    config.alertCount = 0;
    config.maxTime = 0;
    config.lastTime = 0;
    config.video = null;

    initialize(); // Yeniden başlat
  };
  window.edulockOff = () => {
    if (config.video) {
      removeVideoListeners(config.video);
      setError("Video olayları kaldırıldı, edulock durduruldu.");
    }
  };

  document.addEventListener("DOMContentLoaded", () => {
    initializeUI();
    initialize();
  });
})();
